  <ng-template [ngIf]="isOrgPath">
      <div *ngIf="!authOrg.authenticated(); else authenticatedOrg">
          <nav class="navbar navbar-default">
              <div class="container-fluid">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: -15px;" (click)="goToWebsite()">
                    <app-logo></app-logo>
                </a>                  
                </div>
                <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen">
                  <ul class="nav navbar-nav navbar-right">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a [routerLink]="['/org-register']" ><i class="fa fa-check-square-o fa-lg"></i> <span><strong i18n="RegisterLink@@RegisterLink">Register</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a [routerLink]="['/org-forgot-password']" ><i class="fa fa-unlock-alt fa-lg"></i> <span><strong i18n="FYPLink@@lnkFYP">Reset Your Password</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"><a [routerLink]="['/org-login']"  ><i class="fa fa-sign-in fa-lg"></i> <span><strong i18n="@@btnLogin">Sign In</strong></span></a></li>
                  </ul>
                </div>                                    
              </div>
              <select class="pull-right" *ngIf="showLang == true" id="language" [(ngModel)]="selectedLanguage"  (ngModelChange)="updateLanguage()" >                
                  <option *ngFor="let lang of languages"  [selected]="lang.code == _locale" value="{{lang.code}}">{{lang.label}}</option>
              </select>
          </nav>          
      </div>
      <ng-template #authenticatedOrg>
        <nav class="navbar navbar-default">
            <div class="container-fluid">
              <div class="navbar-header">
                  <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>                  
                <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;"  (click)="goToWebsite()">
                    <app-logo></app-logo>
                </a>                
              </div>
              <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen" id="myNavbar1">
                <ul class="nav navbar-nav">
                    <li><a (click)="closeNavbar()" (click)='goBack()' i18n="@@btnGoBack"><i class="fa fa-arrow-left fa-lg"></i> </a></li>                                          
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/org/org-home']"><i class="fa fa-home fa-lg"></i> <span><strong i18n="@@btnHome"> Home</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/org/org-start-referral']"> <span><strong i18n="@@btnStartReferral"> Start Reference</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/org/org-referrer-network']" ><span><strong i18n="@@btnReferrerNetwork"> Network </strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/org/org-report-demo']" ><span><strong i18n="@@btnViewSampleReports"> Samples</strong></span></a></li>
                    <li><a (click)="closeNavbar()" (click)='goForward()' i18n="@@btnGoForward"><i class="fa fa-arrow-right fa-lg"></i>  </a></li>
                </ul>            
                <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown" [class.open]="dropdownOpenOrg">
                      <a class="dropdown-toggle" (click)="toggleDropdown('org', $event)">
                        <i class="fa fa-sitemap fa-lg"></i>
                          <span id="username"><strong>{{authOrg.currentUserValue.refcompany}} ({{authOrg.currentUserValue.reffirstname}})</strong></span>
                          <span class="caret"></span>                        
                      </a>
                      <ul class="dropdown-menu dropdown-menu-right">
                          <li><a (click)="closeNavbar()" [routerLink]="['/org/org-myprofile']"><i class="fa fa-user fa-lg" ></i> <span i18n="@@btnProfile">My Profile</span></a></li>                                                
                          <li class="divider"></li>                          
                          <li><a (click)="closeNavbar()" (click)="authOrg.logout()"  ><i class="fa fa-sign-out fa-lg" ></i> <span i18n="@@btnLogout">Sign Out</span></a></li>                                                                          
                      </ul>
                    </li>
                </ul>
                      
                <!--<ul class="nav navbar-nav navbar-right">                        
                <div class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown"><i class="fa fa-user"></i> <span>{{authOrg.currentUserValue.reffirstname}}</span><span class="caret"></span></a>
                </ul>
                <ul class="dropdown-menu">
                        <li><a><i class="fa fa-user fa-lg" ></i> <span><strong i18n="@@btnProfile">My Profile</strong></span></a></li>                    
                        <li><a (click)="authOrg.logout()"  ><i class="fa fa-sign-out fa-lg" ></i> <span><strong i18n="@@btnLogout">Sign Out</strong></span></a></li>                                                
                </ul>            
                </div>    -->            
              </div>
            </div>
        </nav>                  
      </ng-template>    
  </ng-template>
      
  <ng-template [ngIf]="!isOrgPath && isAdmPath">      
      <div *ngIf="!authAdm.authenticated(); else authenticatedAdm">
          <nav class="navbar navbar-default">
              <div class="container-fluid">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>                  
                <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: -15px;" (click)="goToWebsite()">
                    <app-logo></app-logo>
                </a>
              </div>
                <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen" id="myNavbar">
                  <ul class="nav navbar-nav navbar-right">
                    <li><a (click)="closeNavbar()" [routerLink]="['/adm-login']"  i18n="@@btnLogin"><i class="fa fa-sign-in fa-lg"></i><strong> Sign In</strong></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"><a (click)="closeNavbar()" [routerLink]="['/adm-login']"><i class="fa fa-sign-in fa-lg"></i> <span><strong i18n="@@btnLogin"> Sign In</strong></span></a></li>
                  </ul>
                </div>
              </div>
          </nav>     
          <select class="pull-right" *ngIf="showLang == true" id="language" [(ngModel)]="selectedLanguage"  (ngModelChange)="updateLanguage()" >                
              <option *ngFor="let lang of languages"  [selected]="lang.code == _locale" value="{{lang.code}}">{{lang.label}}</option>
          </select>       
      </div>
      <ng-template #authenticatedAdm>
          <nav class="navbar navbar-default">
              <div class="container-fluid">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>                  
                  <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;"  (click)="goToWebsite()">
                    <app-logo></app-logo>
                  </a>                
                  <!--<h5 class="text-right"> <i class="fa fa-user"></i> <span><strong >  {{authAdm.user.firstname}} &nbsp;&nbsp;</strong></span></h5>-->
                </div>
                <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen" id="myNavbar1">
                    <ul class="nav navbar-nav">
                        <li><a (click)="closeNavbar()" (click)='goBack()'><i class="fa fa-arrow-left fa-lg"></i> </a></li>                                          
                        <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/adm/adm-home']"><i class="fa fa-home fa-lg"></i> <span><strong i18n="@@btnHome"> Home</strong></span></a></li>
                        <li><a (click)="closeNavbar()" (click)='goForward()'><i class="fa fa-arrow-right fa-lg"></i> </a></li>
                    </ul>
                  <ul class="nav navbar-nav navbar-right">
                    <li class="dropdown" [class.open]="dropdownOpenAdm">
                      <a class="dropdown-toggle" (click)="toggleDropdown('adm', $event)">
                        <i class="fa fa-user fa-lg"></i>
                        <span id="username"><strong>{{authAdm.currentUserValue.admincompany}} ({{authAdm.currentUserValue.adminfirstname}})</strong></span>
                        <span class="caret"></span>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li><a (click)="closeNavbar()" [routerLink]="['/adm/adm-myprofile']"><i class="fa fa-user fa-lg"></i> <span i18n="@@btnProfile">My Profile</span></a></li>
                        <li class="divider"></li>
                        <li><a (click)="closeNavbar()" (click)="authAdm.logout()"><i class="fa fa-sign-out fa-lg"></i> <span i18n="@@btnLogout">Sign Out</span></a></li>
                      </ul>
                    </li>                    
                  </ul>
                </div>
              </div>
          </nav>                    
      </ng-template>          
  </ng-template>

  <ng-template [ngIf]="isPdfPath">
        <div>
           <!-- <nav class="navbar navbar-default">
                <div class="container-fluid">
                  <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                    </button>
                    <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;"  (click)="goToWebsite()">
                      <app-logo></app-logo>
                    </a>
                  </div>
                  <div class="collapse navbar-collapse" id="myNavbar">
                  </div>
                </div>
            </nav>    --> 
        </div>
  </ng-template>
  
  <ng-template [ngIf]="!isAdmPath && !isOrgPath && !isPdfPath">
      <div *ngIf="!auth.authenticated(); else authenticated">
          <nav class="navbar navbar-default">
              <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                      <span class="sr-only">Toggle navigation</span>
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                    </button>                  
                  <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;"  (click)="goToWebsite()">
                    <app-logo></app-logo>
                  </a>
                </div>
                <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen" id="myNavbar">
                  <ul class="nav navbar-nav navbar-right">
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a [routerLink]="['/ind-register']" ><i class="fa fa-check-square-o fa-lg"></i> <span><strong i18n="RegisterLink@@RegisterLink"> Register</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a [routerLink]="['/ind-forgot-password']" ><i class="fa fa-unlock-alt fa-lg"></i> <span><strong i18n="FYPLink@@lnkFYP"> Reset Your Password</strong></span></a></li>
                    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"><a [routerLink]="['/ind-login']"  ><i class="fa fa-sign-in fa-lg"></i> <span><strong i18n="@@btnLogin"> Sign In</strong></span></a></li>
                  </ul>
                </div>
              </div>
              <select class="pull-right" *ngIf="showLang == true" id="language" [(ngModel)]="selectedLanguage"  (ngModelChange)="updateLanguage()" >                
                  <option *ngFor="let lang of languages"  [selected]="lang.code == _locale" value="{{lang.code}}">{{lang.label}}</option>
              </select>                    
          </nav>          
      </div>
      <ng-template #authenticated>
          <nav class="navbar navbar-default">
              <div class="container-fluid">
                <div class="navbar-header">
                  <button type="button" class="navbar-toggle" (click)="toggleNavbar($event)">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>                  
                    <a class="navbar-brand" style="float:left; padding: 0; height: 50px; display: flex; align-items: center; margin-left: 5px;"  (click)="goToWebsite()">
                        <app-logo></app-logo>
                    </a>                
                    <!--<h5 class="text-right"> <i class="fa fa-user"></i> <span><strong >  {{auth.currentUserValue.firstname}} &nbsp;&nbsp;</strong></span></h5>-->
                </div>                  
                <div class="navbar-collapse" [class.in]="navbarOpen" [class.collapse]="!navbarOpen" id="myNavbar2">
                    <ul class="nav navbar-nav">
                        <li><a (click)="closeNavbar()" (click)='goBack()'  i18n="@@btnGoBack"><i class="fa fa-arrow-left fa-lg"></i> </a></li>                                          
                        <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/ind/ind-home']" ><i class="fa fa-home fa-lg"></i> <span><strong i18n="@@btnHome"> Home</strong></span></a></li>
                        <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a (click)="closeNavbar()" [routerLink]="['/ind/ind-start-referral']"> <span><strong i18n="@@btnStartSelfReferral"> Start Self Reference</strong></span></a></li>
                        <li><a (click)="closeNavbar()" (click)='goForward()' i18n="@@btnGoForward"><i class="fa fa-arrow-right fa-lg"></i>  </a></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                      <li class="dropdown" [class.open]="dropdownOpenInd">
                        <a class="dropdown-toggle" (click)="toggleDropdown('ind', $event)">
                          <i class="fa fa-user fa-lg"></i>
                          <span id="username"><strong>{{auth.currentUserValue.firstname}}</strong></span>
                          <span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right">
                                <li><a (click)="closeNavbar()" [routerLink]="['/ind/ind-myprofile']"><i class="fa fa-user fa-lg" ></i> <span i18n="@@btnProfile">My Profile</span></a></li>
                                <li class="divider"></li>                          
                                <li><a (click)="closeNavbar()" (click)="auth.logout()"  ><i class="fa fa-sign-out fa-lg" ></i> <span i18n="@@btnLogout">Sign Out</span></a></li>
                        </ul>
                      </li>                      
                    </ul>
                </div>
              </div>
          </nav>  
      </ng-template>
  </ng-template>

<main id="mainapp">        
    <!--flash-messages></flash-messages-->    
    <router-outlet></router-outlet>
    <app-footer></app-footer>  
</main>
